import { ArrowRight, Layers3, Sprout } from "lucide-react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { ErrorState, LoadingState } from "../components/StateViews";
import { StatusPill } from "../components/StatusPill";
import { useEstufaData } from "../lib/queries";

export function PortfolioPage() {
  const query = useEstufaData();
  if (query.isLoading) return <LoadingState />;
  if (query.isError || !query.data) return <ErrorState />;
  const { seeds, deployments, releases, incidents } = query.data;
  return (
    <>
      <PageHeader
        eyebrow="Todas as plantas"
        title="Portfólio"
        description="Publicadas, em construção, pausadas ou mortas. Nada some porque tudo ensina."
      />
      <div className="seed-grid">
        {seeds.map((seed, index) => {
          const deps = deployments.filter((item) => item.seedId === seed.id);
          const latest = releases.find((release) =>
            deps.some((dep) => dep.id === release.deploymentId),
          );
          const openIncidents = incidents.filter(
            (incident) =>
              incident.deploymentId &&
              deps.some((dep) => dep.id === incident.deploymentId) &&
              incident.status !== "resolved",
          ).length;
          return (
            <Link to={`/portfolio/${seed.id}`} className="seed-card" key={seed.id}>
              <div className={`seed-card-accent seed-card-accent--${index % 4}`} />
              <div className="seed-card-top">
                <div className="seed-icon">
                  <Sprout size={23} />
                </div>
                <StatusPill value={seed.status} />
              </div>
              <div>
                <span className="eyebrow">{seed.seedKey}</span>
                <h2>{seed.name}</h2>
                <p>{seed.summary ?? "Sem resumo."}</p>
              </div>
              <div className="seed-card-meta">
                <span>
                  <Layers3 size={15} />
                  {deps.map((item) => item.platformSlug).join(" · ") || "Sem deployment"}
                </span>
                <span>Release {latest?.version ?? "—"}</span>
                <span>{openIncidents} incidentes abertos</span>
              </div>
              <div className="seed-card-link">
                Abrir Seed <ArrowRight size={17} />
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
}
